import { render } from "./AddAdmin.vue?vue&type=template&id=b21de434"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/vestment25/upgrading/jarvis-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__